import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { SyntheticEvent } from 'react';

import { ArticleSummary } from '@/redux/modules/article/article.types';
import { addImageParams, imagePlaceholder } from '@/utils/urls';

type ArticleLinkCardImageProps = Pick<ArticleSummary, 'heroImageUrl' | 'secondaryImageUrl' | 'title'> & {
    className: string;
};

const IMAGE_SIZE = 380;

const getOptimizedSrc = (url: string | null) => {
    const optimized = addImageParams({
        height: IMAGE_SIZE,
        sharpen: true,
        url: url ?? '',
        width: IMAGE_SIZE,
    });

    return optimized || imagePlaceholder;
};

const handleImageError = (event: SyntheticEvent<HTMLImageElement>) => {
    const target = event.target as HTMLImageElement;
    if (target.src !== imagePlaceholder) {
        target.src = imagePlaceholder;
        target.onerror = null;
    }
};

export const ArticleLinkCardImage = ({
    className,
    heroImageUrl,
    secondaryImageUrl,
    title,
}: ArticleLinkCardImageProps) => {
    const primarySrc = getOptimizedSrc(heroImageUrl);
    const secondarySrc = getOptimizedSrc(secondaryImageUrl);

    return (
        <div className={cn('flex w-full border-b-2 border-border-black bg-background-primary', className)}>
            <img
                alt={title}
                className="aspect-square min-w-0 flex-1 object-cover"
                height={IMAGE_SIZE}
                loading="lazy"
                onError={handleImageError}
                src={primarySrc}
                width={IMAGE_SIZE}
            />
            <img
                alt=""
                className="aspect-square min-w-0 flex-1 object-cover"
                height={IMAGE_SIZE}
                loading="lazy"
                onError={handleImageError}
                src={secondarySrc}
                width={IMAGE_SIZE}
            />
        </div>
    );
};
